import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import brandLogo from '../../assets/brand-logo.png';

// Minimal frame for the vendor area: a top bar with identity and logout.
// No sidebar — vendors have one device list and the pages under it.
const VendorLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/vendor-login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-primary-900 to-primary-700 shadow-lg">
        <div className="px-4 h-16 flex items-center justify-between">
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => navigate('/vendor')}
          >
            <img src={brandLogo} alt="Dryer Master" className="block h-8 w-auto" />
            <div className="h-8 w-px bg-white/25" />
            <h1 className="text-xl font-bold text-white tracking-wide">DM Vendor</h1>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-medium text-white">{user?.email}</p>
              <p className="text-xs text-primary-200">{user?.sellerName || 'Vendor'}</p>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-white hover:bg-white/10 transition-colors"
              title="Logout"
            >
              <ArrowRightOnRectangleIcon className="w-5 h-5" />
              <span className="text-sm font-medium">Logout</span>
            </button>
          </div>
        </div>
      </nav>

      <main className="pt-16">
        <div className="p-6 max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default VendorLayout;
